<template>
  <div class="main" v-if="bodyShow">
    <!-- 公用头部 -->
    <public-header :colors="'#F0F0F0'" :headimg="headImg"></public-header>
    <!--  -->
    <div v-for="(item,index) in list" :key="index" :class="{'on':list[list.length-1]==list[index]}" class="list clearfix">
      <router-link :to="{
          path: '/ta_project_details',
          query: {
            'cid': cid,
            'cpid': item.id,
            // 'ctype':(index==0?true:false)
            'ctype': false
          }
        }
      ">
        <h2>{{item.name}}</h2>
        <div class="left pull-left clearfix">
          <p v-if="item.groupCompleteCount">小组完成人数：<span>{{item.groupCompleteCount }}</span></p>
          <p v-if="item.endtime">报告完成截止时间：<span>{{item.endtime}}</span></p>
        </div>
        <img class="pull-right clearfix" src="@a/right_.png" alt="">
      </router-link>
    </div>
    <!--  -->
    <router-link v-if="complete" :class="['sub-btn',complete?'active':'']" :to="{
        path:'/person_report_new',
        query:{
          cid
        }
      }"
    >
      领取个人报告
    </router-link>
    <a v-else class="sub-btn" >
      领取个人报告
    </a>
  </div>
</template>
<script>
import { projectList } from "@/api/assistant"
import { shareCon } from "@/utils/wxconfig";

export default {
  data() {
      return {
        bodyShow: false,
        headImg: '',
        list: [],
        complete: false,
        cid: ""
      }
    },
    methods: {
      pullData() {
        this.cid = this.$route.query.cid;
        projectList({
          cid: this.$route.query.cid
        }).then((data) => {
          if(data.code==10002){
            this.$toast(data.data.msg);
            return;
          }
          this.headImg = data.userdetail.headimgurl;
          this.list = data.project;
          this.complete = data.complete;
          this.bodyShow = true;
        })
      }
    },
    created(){
        this.pullData();
        shareCon("course",this);
    }
}
</script>
<style lang="scss" scoped>
.main {
  .list {
    margin: 30px;
    padding: 46px 30px;
    background-color: #ffffff;
    border-radius: 8px;
    h2 {
      font-size: 32px;
      font-weight: bold;
      color: #333333;
    }
    .left {
      p {
        font-size: 24px;
        color: #666666;
        span {
          color: #EB5032;
        }
      }
    }
    img {
      width: 16px;
      height: 27px;
    }
  }
  .on {
    margin-bottom: 80px;
  }
  .sub-btn {
    display: block;
    text-align: center;
    margin: 0 auto 80px;
    width: 578px;
    line-height: 80px;
    font-size: 34px;
    background-color: #CCCCCC;
    color: #ffffff;
    border-radius: 8px;
  }
  .sub-btn.active {
    background-color: #EB5032;
  }
}
</style>
